<div role="alert"
  *ngIf="(_getContactPhones() | async).length > 0"
  [ngClass]="{'alert-waiting-room': inCall, 'alert alert-waiting-tutorial alert-warning': !inCall}">
  <p>{{ 'audioWarningMsg1' | translate}} <strong>{{_getContactPhones() | async}}</strong> {{ 'audioWarningMsg2' | translate }}</p>
</div>
